import * as adUI from '@aprildirect/april-direct-ui/lib/store/ui'

const state = adUI.state
const mutations = adUI.mutations
const actions = adUI.actions

export { state, mutations, actions }
